export default __webpack_public_path__ + "static/media/myosh-logo.84c8a672.png";